import React from "react";
import style from "./table.module.scss";

interface TableColumn {
  key: string;
  header: string;
  render?: (value: any, row: any) => React.ReactNode;
  className?: string;
  headerClassName?: string;
}

interface TableProps {
  columns: TableColumn[];
  data: any[];
  loading?: boolean;
  emptyMessage?: string;
  className?: string;
  onRowClick?: (row: any) => void;
}

const Table: React.FC<TableProps> = ({
  columns,
  data,
  loading = false,
  emptyMessage = "No data available",
  className = "",
  onRowClick,
}) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <p className="text-muted">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div
      className={`custom-table-container ${className}`}
      style={{ height: "100%", minHeight: 0, overflow: "auto" }}
    >
      <table
        className="table table-hover mb-0"
        style={{ tableLayout: "auto", width: "100%" }}
      >
        <thead className="bg-dark sticky-top shadow-none">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={`px-5 py-3 border-0 fw-semibold ${column.headerClassName || ""}`}
                style={{
                  fontSize: "14px",
                  // position: "sticky",
                  top: 0,
                  backgroundColor: "#ffffff",
                  zIndex: 10,
                }}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={`${style.table_tr_hover_state}`}>
          {(data || [])?.map((row, index) => (
            <tr
              key={`row-${index}`}
              className={`${onRowClick ? "cursor-pointer" : ""}`}
              onClick={() => onRowClick?.(row)}
              style={{
                borderBottom: "1px solid #EEEEEE",
              }}
            >
              {columns.map((column, colIndex) => (
                <td
                  key={`${column.key}-${index}-${colIndex}`}
                  className={`px-5 py-3 ${column.className || ""}`}
                  style={{ fontSize: "14px" }}
                >
                  {column?.render
                    ? column.render(row[column.key], row)
                    : row[column.key] || "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
